//import { Helmet } from 'react-helmet';

import {Helmet} from "react-helmet";

interface ClientType {
    client_id: string;
    client_name: string;
}

interface ClientsType {
    clients: ClientType[];
}

const Clients = ({clients} : ClientsType) => {
    return (
        <div>
            <Helmet>
                <title>Clients | A. Page Code</title>
                <meta name="description" content="A List of Clients" />
            </Helmet>
            {clients.map((client: ClientType) => (
                <div className="card" key={client.client_id}>
                    <div className="card-body">
                        <h5 className="card-title">{client.client_name}</h5>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Clients;